import {SearchOverdraftCustomerResult} from "../pismo.domain";

export type OverdraftCustomerSearchValue = SearchOverdraftCustomerResult[number] | null
